// removed by extract-text-webpack-plugin
module.exports = {"button":"styles__button__1B4i6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/styles.less
// module id = 174
// module chunks = 0